"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consentPolicySsrApiFactory = void 0;
const viewer_service_environment_1 = require("@wix/viewer-service-environment");
const utils_1 = require("./utils");
const consentPolicySsrApiFactory = (config, getService) => {
    const envService = getService(viewer_service_environment_1.EnvironmentDefinition);
    const isWixSite = envService.isWixSite;
    const updateCommonConfig = config.updateCommonConfig;
    const defaultPolicy = isWixSite ? utils_1.wixSitesDefaultPolicy : config.siteConsentPolicy || utils_1.userSitesDefaultPolicy;
    const defaultPolicyDetails = {
        defaultPolicy: true,
        policy: defaultPolicy,
    };
    const defaultPolicyHeaderObject = isWixSite || config.siteConsentPolicy ? (0, utils_1.consentPolicyToHeaderObject)(defaultPolicy) : {};
    updateCommonConfig &&
        updateCommonConfig({
            consentPolicy: defaultPolicy,
            consentPolicyHeader: defaultPolicyHeaderObject,
        });
    const api = {
        getCurrentConsentPolicy() {
            return defaultPolicyDetails;
        },
        _getConsentPolicyHeader() {
            return defaultPolicyHeaderObject;
        },
        setConsentPolicy() {
            return Promise.resolve(defaultPolicyDetails);
        },
        resetConsentPolicy() {
            return Promise.resolve();
        },
        registerToChanges() {
            return () => { };
        },
        publishPolicyUpdateRequestedEvent() { },
    };
    return api;
};
exports.consentPolicySsrApiFactory = consentPolicySsrApiFactory;
//# sourceMappingURL=consentPolicySsrApiFactory.js.map